export default __webpack_public_path__ + "static/media/1492509282_photos_ios7_ios_7.9cb9de07.png";